import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansRepaymentFormComponent from './loansRepaymentForm.component';

let loansRepaymentFormModule = angular.module('loansRepaymentForm', [
  uiRouter
])

.component('loansRepaymentForm', loansRepaymentFormComponent)

.name;

export default loansRepaymentFormModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentForm/loansRepaymentForm.js